import { render, staticRenderFns } from "./MachineInfo.vue?vue&type=template&id=2d4d3ec6"
import script from "./MachineInfo.vue?vue&type=script&lang=js"
export * from "./MachineInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports